<template>
    <div id="bindPhone">

        <van-cell-group>
          <van-field 
            v-model="recordLoginText"
            clearable
            left-icon="info-o"
            placeholder="请输入iccid" 
            disabled=true
          />

          <van-field 
            v-model="name"
            clearable
            left-icon="user-o"
            placeholder="请输入真实姓名" 
            :disabled='isFirst == 2'
          />

          <van-field 
            v-model="idcard"
            clearable
            maxlength="18"
            left-icon="idcard"
            placeholder="请输入身份证号" 
            :disabled='isFirst == 2'
          />

          <van-field 
            v-model="userPhone"
            maxlength="11"
            clearable
            left-icon="phone-o"
            placeholder="请输入11位手机号码" 
            :disabled='isFirst == 2'
          />

          <van-field
            v-model="smsCode"
            clearable
            maxlength="6"
            left-icon="other-pay"
            placeholder="请输入验证码" 
            :disabled='isFirst == 2'
            >
            <van-button slot="button" type="primary" size="small" 
            :disabled="smsFlag" class="codeBtn" @click="getSmsCode">获取验证码</van-button>
          </van-field>


        </van-cell-group>

        
        <!-- <p class="tip" style="text-align: center;" v-if="cardType==1 || cardType==5">请先绑定手机号</p> -->

        <div class="footer" style="display:flex;">
            <van-button type="primary" style="flex:1;margin-right:10px;" @click.prevent="payRealName" v-if="isFirst == 2">支付实名费用</van-button>
            <van-button type="primary" style="flex:1;margin-right:10px;"  :disabled="bindFlag" @click.prevent="bindPhoneSetHandler" v-else>绑定手机号</van-button>
            <van-button type="primary" style="flex:1;"  @click="logoutHandler()">退 出</van-button> 
        </div> 
        <div style="color: #f76161;margin: 15px 15px 0 15px;line-height: 24px;">
            <p>温馨提示：</p>
            <p>1、请确保您的实名手机号，姓名，身份证信息三者保持一致，否则将无法通过验证！</P>
            <p>2、用户第一次申请验证，无需支付费用，第二次开始每次认证需支付0.5元信息认证费。请确保填写信息正确，以免产生额外费用，谢谢！</P>
        </div>
    </div>
</template>
<script>
import { wxRequest} from '@/api/user.js'
import { setInterval, setTimeout } from 'timers';

import { Dialog } from 'vant';
export default {
    data(){
        return {
            recordLoginText:localStorage.getItem('recordLoginText'),
            iccid: localStorage.getItem('iccid'),
            userPhone: '',
            idcard: '',
            smsCode: '',
            btnTxt: '发送验证码',
            name:'',
            cardType: null,
            isFirst: 0,
            isApp: '', //从app跳转进来
        }
    },
    methods: {
        logoutHandler(){
            if(!this.isApp){
                window.location.href = 'http://exit_idcard'
            }else {
                localStorage.removeItem("iccid");
                //若为总部微信公众号
                if(this.$store.state.isHeadquarterAppid=='true'){
                    window.location.href = window.location.origin + '/'; 
                }
                //若为代理商微信公众号
                else{
                    window.location.href = window.location.origin + '/?source=' + localStorage.getItem('appid');
                }
            }
        },
        getSmsCode(){
            var data = {
                userPhone: this.userPhone
            }
            wxRequest("bindPhone/sms/code", data, "post").then(res => {
                if(res.data.code == 200){
                    var n = 60;
                    this.btnTxt = '重新发送' + n +'s';
                    let timer = window.setInterval(() => {   
                        n--;                     
                        this.btnTxt = '重新发送' + n +'s';
                        if(n < 1){
                            window.clearInterval(timer);
                            this.btnTxt = '发送验证码';
                        }
                    },1000)
                }else{
                    Dialog.alert({title: "提示", message:res.data.message});
                }
            })
        },
        bindPhoneSetHandler(){
            var data = this.$data;
            data.iccid=this.iccid;
            // if(this.cardType==1 || this.cardType==5){
            //     data.name = '电信用户',
            //     data.idcard = '000'
            // }
            wxRequest("bindPhone/phone", data, "post").then(res => {
                let _this = this;
                if(res.data.code == 200){
                    localStorage.setItem('phoneNo', _this.userPhone);
                    localStorage.setItem('mobile', _this.userPhone);
                    if(this.isApp){
                        _this.$router.push('/user/home')
                    }else {
                        window.location.href = 'http://sucess_idcard'
                    }
                }else if(res.data.code == 777){
                    Dialog.alert({message: res.data.message,}).then(() => {//跳转到支付实名费用
                        this.isFirst = 2;
                        this.userPhone = '';
                        this.idcard = '';
                        this.smsCode = '';
                        this.name = '';
                        this.btnTxt = '发送验证码';
                    });
                }else {
                    Dialog.alert({title: "提示", message:res.data.message});
                }
            })
        },
        //支付实名
        payRealName(){
            if(!this.isApp){
                window.location.href = 'http://payidcard'
            }else {
                let fd = new FormData();
                fd.append("iccid", this.iccid);
                let _this = this;
                wxRequest('order/bind/phone', fd, 'post').then(res => {
                    let param = res.data.data.param;        
                    WeixinJSBridge.invoke(
                        'getBrandWCPayRequest', param,
                        function(res){
                            if(res.err_msg == "get_brand_wcpay_request:ok" ){
                                //若为总部
                                if(this.$store.state.isHeadquarterAppid=='true') {
                                    window.location.href = 'http://webchat.szxxtx.com'
                                }
                                //代理商
                                else {
                                    window.location.href = window.location.origin + '?source=' + localStorage.getItem('appid');
                                }
                            } 
                        }
                    );
                })
            }
        }

    },
    mounted(){
        this.iccid = localStorage.getItem('iccid') || this.$route.query.iccid;
        this.cardType = this.$route.query.cardType;
        this.isFirst = this.$route.query.isFirst;
        this.isApp = localStorage.getItem('iccid')
        if(this.isFirst == 2){
            Dialog({ message: '尊敬的用户，您当前有未支付的实名失败订单，请你优化支付完订单信息，再重新登录实名认证。' });
        }
    },
    computed: {
        bindFlag(){
            if(this.userPhone.length == 11 && this.smsCode.length >= 4){                
                return false;
            }else{                
                return true;
            }
        },
        smsFlag(){
            if(this.userPhone.length == 11 && this.btnTxt == '发送验证码'){
                return false;
            }else{
                return true;
            }
        },

    },
}
</script>
<style lang="less" scoped>
#bindPhone {
    ul {
        margin: 10px;
        li {
            line-height: 36px;
            padding: 3px 0;
            border-bottom: 1px solid #ffa33a;
            svg {
                vertical-align: middle;
                margin-right: 8px;
            }
            .codeBtn {
                float: right;
                margin-top: 2px;
            }
        }
    }
    .footer {
        padding: 15px 10% 0;
    }

    .tip{
        color: #f76161;
        margin: 15px 15px 0 15px;
        line-height: 24px;

    }
}
</style>

<style>
#bindPhone input.van-field__control{
    padding-left: 5px;
    line-height: 24px;
}

</style>
